import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SettingsService } from './settings.service';
import { StorageService } from './storage.service';
import { Observable } from 'rxjs';
import { FileItem } from 'app/models';
import {map} from 'rxjs/operators';

@Injectable()
export class DocumentsService {
  apiUrl: string;
  token: string;

  constructor(private http: HttpClient,
              private settings: SettingsService,
              private storage: StorageService) {
    this.apiUrl = this.settings.apiUrl;
    this.token = this.storage.accessToken;
  }

  uploadFile(file: any, parentType: string, parentId: number, folder?: any): Observable<FileItem> {
    return this.http.post(`${this.apiUrl}/${parentType}/${parentId}/document`, file)
      .pipe(map((resp: any) => {
      return new FileItem().setFromApiModel(resp);
    }));
  }

  deleteFile(fileId: number, parentType: string, parentId: number) {
    return this.http.delete(`${this.apiUrl}/${parentType}/${parentId}/document/${fileId}`);
  }

  updateFile(file: any, parentType: string, parentId: number): Observable<FileItem> {
    return this.http.put(`${this.apiUrl}/${parentType}/${parentId}/document/${file.id}`, {
      comment: file.comment,
      origin_name: file.nameShort
    }).pipe(map((resp: any) => {
      return new FileItem().setFromApiModel(resp);
    }));
  }

  updateFolder(folder: any, parentType: string, parentId: number): Observable<FileItem> {

    return this.http.put(`${this.apiUrl}/${parentType}/${parentId}/folder/${folder.id}`, {
      name: folder.name,
    }).pipe(map((resp: any) => {
      return resp;
    }));
  }

  createFolder(parentId: number, parentType: string, data: any) {
    return this.http.post(`${this.apiUrl}/${parentType}/${parentId}/folder`, data).pipe(map((resp: any) => {
      return resp;
    }));
  }

  deleteFolder(folderId: number, parentType: string, parentId: number) {
    return this.http.delete(`${this.apiUrl}/${parentType}/${parentId}/folder/${folderId}`);
  }

  getFile(file: any) {
    return this.http.get(`${this.apiUrl}/file/${file.name}`, {responseType: 'blob'});
  }
}
